// src/pto/components/PtoPages.js
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import SideNavigationMenu from "./common/SideNavigationMenu";
import DashboardPage from "./dashboard/DashboardPage";
import { Row, Col } from "react-bootstrap";
import PtoBalanceBySubaccountYtd from "./reports/PtoBalanceBySubaccountYtd/PtoBalanceBySubaccountYtd";
import ManagerPtoDashboard from "./manager/ManagerPtoDashboard";
import ManagerEmployeeDetails from "./manager/ManagerEmployeeDetails";
import AdminPtoDashboard from "./admin/AdminPtoDashboard";
import AdminEmployeeDetails from "./admin/AdminEmployeeDetails";
import { useImpersonation } from "../../contexts/ImpersonationContext";

const PtoPages = ({ ptoProfile }) => {
  const { impersonation } = useImpersonation();
  const location = useLocation();
  
  // Check for impersonation in URL on component mount
  useEffect(() => {
    // Check if URL has impersonation
    const impersonationMatch = location.pathname.match(/\/as\/(\d+)/);
    if (impersonationMatch && impersonationMatch[1]) {
      // Save for restoration
      const impersonatedId = parseInt(impersonationMatch[1], 10);
      sessionStorage.setItem('pendingImpersonation', impersonatedId.toString());
    }
  }, [location.pathname]);
  
  // Create a profile that includes impersonation details if impersonating
  const combinedProfile = impersonation ? {
    // Base profile properties
    ...ptoProfile,
    // Override with impersonation data
    dataEmployeeId: impersonation.impersonatedId,
    isImpersonation: true,
    // Other properties remain intact
  } : ptoProfile;

  // Helper to build impersonation-aware route paths
  const buildRoutePath = (basePath) => {
    if (impersonation) {
      return `${basePath}/as/${impersonation.impersonatedId}`;
    }
    return basePath;
  };

  return (
    <>
      <Col className="rev-share-nav" xl="2" lg="3" md="4">
        <SideNavigationMenu isAdmin={combinedProfile.isAdmin} isManager={combinedProfile.isManager} />
      </Col>
      <Col xl="10" lg="9" md="8">
        <Row>
        </Row>
        <Row>
          <Switch>
            <Route exact path="/pto">
              <Redirect to="/pto/details" />
            </Route>
            <Route 
              exact 
              path={buildRoutePath("/pto/reports/ptobalancebysubaccountytd")} 
              component={PtoBalanceBySubaccountYtd} 
            />
            {/* Manager Routes */}
            <Route 
              exact 
              path={buildRoutePath("/pto/manager/dashboard")} 
              render={() => <ManagerPtoDashboard profile={combinedProfile} />} 
            />
            <Route 
              path="/pto/manager/employee/:employeeId?" 
              render={() => <ManagerEmployeeDetails profile={combinedProfile} />} 
            />
            {/* Admin Routes */}
            <Route 
              exact 
              path="/pto/admin/dashboard" 
              render={() => <AdminPtoDashboard profile={combinedProfile} />} 
            />
            <Route 
              path="/pto/admin/employee/:employeeId?" 
              render={() => <AdminEmployeeDetails profile={combinedProfile} />} 
            />

            {/* User Routes */}
            <Route 
              exact 
              path={buildRoutePath("/pto/details")} 
              render={() => <DashboardPage profile={combinedProfile} />} 
            />
          </Switch>
        </Row>
      </Col>
    </>
  );
};

const mapStateToProps = (state) => {
  // Determine if we're in impersonation mode
  const isImpersonation = !!state.profile.ghost && state.profile.isAdmin;
  
  // Create a simplified PtoProfile object with only what we need
  const ptoProfile = {
    // Use ghost values when in impersonation mode, otherwise use regular profile values
    ptoEmployeeId: isImpersonation ? state.profile.ghostPtoEmployeeId : state.profile.ptoEmployeeId,
    dataEmployeeId: isImpersonation ? state.profile.ghostDataEmployeeId : state.profile.dataEmployeeId,
    isAdmin: isImpersonation ? state.profile.ghostIsAdmin : state.profile.isAdmin,
    isManager: isImpersonation ? state.profile.ghostIsManager : state.profile.isManager,
    isImpersonation: isImpersonation,
  };

  return { ptoProfile };
};

export default connect(mapStateToProps)(PtoPages);